import { useQuery } from "@tanstack/react-query";

export function useNexusVersion() {
  return useQuery({
    queryKey: ["nexus-version"],
    queryFn: async ({ signal }): Promise<string | null> => {
      const base =
        (import.meta.env.VITE_API_ENDPOINT as string | undefined) || window.location.origin;
      const response = await fetch(`${base.replace(/\/$/, "")}/api/info`, {
        signal: AbortSignal.any([signal, AbortSignal.timeout(10_000)]),
        cache: "no-store",
        credentials: "omit",
      });
      if (!response.ok) throw new Error("Version information unavailable.");
      const info: unknown = await response.json();
      if (!info || typeof info !== "object" || !("api" in info)) return null;
      const api = info.api;
      if (!api || typeof api !== "object") return null;
      const tag = "tag" in api && typeof api.tag === "string" ? api.tag.trim() : "";
      const version = "version" in api && typeof api.version === "string" ? api.version.trim() : "";
      if (tag) return tag;
      if (!version) return null;
      return version === "dev" || version.startsWith("git-") ? "Preview" : version;
    },
    staleTime: 5 * 60_000,
    retry: false,
  });
}
